// 简体中文 — mirrors en.js key for key. zh/ja/ko only use the CLDR "other"
// plural category, so plural entries only carry the _other form.
const zhCN = {
  // ===== shared =====
  'common.createPlan': '创建计划',
  'common.save': '保存',
  'common.cancel': '取消',
  'common.delete': '删除',
  'common.edit': '编辑',
  'common.retry': '重试',
  'common.activate': '启用',
  'common.deactivate': '停用',
  'common.enabled': '已启用',
  'common.disabled': '已禁用',
  'common.viewTerms': '查看条款',
  'common.untitledPlan': '未命名计划',
  'common.savedToast': '保存成功',

  // ===== nav / chrome =====
  'nav.home': '首页',
  'nav.plans': '计划',
  'nav.settings': '设置',

  'mismatch.title': '部署环境不匹配',
  'mismatch.body': '此前端构建调用的 API 是 {apiBase},但当前由 {hostname} 提供(预期为 {expected})。',
  'mismatch.contact': '请联系技术支持 —— 这是部署配置错误,与您的账号无关。',

  'install.title': '无法连接到 Shopify',
  'install.body': '请检查后端是否正在运行,以及其 SHOPIFY_API_KEY 是否与 shopify.app.toml 中应用的 client_id 一致。',
  'install.retry': '重试',

  'chrome.loadingBrand': 'FlexCover 正在加载…',
  'error.title': '出错了',
  'error.reload': '重新加载',

  'support.badge': '客服视角',
  'support.shopUnknown': '(店铺未知)',
  'support.expired': '令牌已过期 —— 请回支持后台重新生成',
  'support.validUntil': '令牌有效期至 {time}',
  'support.exit': '退出',

  // ===== Home =====
  'home.title': '欢迎使用 FlexCover: Protection Plans 👋',
  'home.last30days': '近 30 天',
  'home.loadingChart': '图表加载中',
  'home.loadingOverview': '概览加载中',
  'home.statOrders': '含保护计划的订单',
  'home.statRevenue': '保护计划总收入',
  'home.gettingStarted': '新手引导',
  'home.allSet': '全部完成 🎉',
  'home.completed': '已完成 {done}/{total}',
  'home.step1.title': '创建第一个保护计划',
  'home.step1.desc': '设置保护服务的价格、保障范围和购物车展示样式。',
  'home.step2.title': '启用应用嵌入',
  'home.step2.desc': '打开 FlexCover: Protection Plans 区块,让保护小组件出现在您的购物车中。',
  'home.step2.enable': '启用应用嵌入',
  'home.step2.check': '检查状态',
  'home.step3.title': '获得第一笔受保护订单',
  'home.step3.desc': '小组件上线后,顾客可在购物车中添加保护计划 —— 总金额会显示在上方卡片中。',
  'home.appEmbed': '应用嵌入',
  'home.checkingEmbed': '正在检查应用嵌入状态',
  'home.embedEnabledBody': '保护小组件已在您的店铺前台生效。',
  'home.embedTheme': '(主题:{theme})',
  'home.embedDisabledBody': '应用目前在您的店铺前台未启用。',
  'home.embedUnknown': '未知',
  'home.embedUnknownBody': '应用连接到店铺后即可查看前台状态。',
  'home.embedUnknownReason': '暂时无法读取您的线上主题。',
  'home.enableEmbedHint': '在 Shopify 后台,依次进入 Online Store → Themes → Customize → App embeds,然后打开 FlexCover: Protection Plans 开关。',
  'home.learnMorePrefix': '了解更多:',
  'home.learnMoreLink': '如何使用保护计划',

  // ===== Plans list =====
  'plans.title': '计划',
  'plans.loading': '计划加载中',
  'plans.errorTitle': '无法加载计划',
  'plans.empty.heading': '创建您的第一个保护计划',
  'plans.empty.body': '提供运费保护、延长保修、退货保障和自定义保障 —— 定价方式由您决定。',
  'plans.loadDemo': '加载示例计划',
  'plans.demoLoaded': '示例计划已加载',
  'plans.demoFailed': '加载示例计划失败:{message}',
  'plans.filterPlaceholder': '筛选计划',
  'plans.addFilter': '添加筛选',
  'plans.statusHeading': '状态',
  'plans.typeHeading': '保护类型',
  'plans.statusActive': '已启用',
  'plans.statusInactive': '已停用',
  'plans.showing_other': '显示 {count} 个计划',
  'plans.sortBy': '排序方式',
  'plans.selectAll': '选择全部计划',
  'plans.selectedCount': '已选 {count} 项',
  'plans.bulkDeleted_other': '已删除 {count} 个计划',
  'plans.bulkActivated_other': '已启用 {count} 个计划',
  'plans.bulkDeactivated_other': '已停用 {count} 个计划',
  'plans.deleteBulkFailed': '删除失败:{message}',
  'plans.updateBulkFailed': '更新失败:{message}',
  'plans.activated': '计划已启用',
  'plans.deactivated': '计划已停用',
  'plans.updateFailed': '更新计划失败:{message}',
  'plans.deleted': '计划已删除',
  'plans.deleteFailed': '删除计划失败:{message}',
  'plans.actionsFor': '「{name}」的操作',
  'plans.activatePlan': '启用 {name}',
  'plans.deactivatePlan': '停用 {name}',
  'plans.onlineStore': '在线商店',
  'plans.optional': '可选',
  'plans.automatic': '自动',
  'plans.noMatch': '没有符合搜索或筛选条件的计划。',
  'plans.deleteTitle': '删除保护计划?',
  'plans.deleteBody': '将立即从您的店铺中移除,顾客将不再看到此保护选项。',
  'plans.helpPrefix': '需要帮助?',
  'plans.helpLink': '联系我们',
  'plans.helpSuffix': ',或查看应用文档和用户教程。',

  'sort.date': '日期(从新到旧)',
  'sort.name': '名称(A–Z)',
  'sort.sortOrder': '购物车排序',
  'sort.price': '价格(从低到高)',

  'planType.shipping_protection': '运费保护',
  'planType.warranty': '延长保修',
  'planType.return_insurance': '退货保障',
  'planType.custom': '自定义保障',
  'planTypeShort.shipping_protection': '运费',
  'planTypeShort.warranty': '保修',
  'planTypeShort.return_insurance': '退货',
  'planTypeShort.custom': '自定义',
  'priceType.fixed': '固定金额',
  'priceType.percentage': '订单百分比',

  // ===== Plan editor page shell =====
  'plan.pageTitle': '保护计划',
  'plan.loading': '计划加载中',
  'plan.notFound.heading': '未找到计划',
  'plan.notFound.body': '该保护计划可能已被删除。',
  'plan.backToPlans': '返回计划列表',
  'plan.newTitle': '新建保护计划',
  'plan.newSubtitle': '配置定价和购物车展示,然后创建计划',
  'plan.subtitle': '保存后更改才会应用到您的店铺',
  'plan.statusTitle': '计划状态',
  'plan.saveFailed': '保存计划失败:{message}',

  // ===== Plan editor form =====
  'form.section.type': '保护类型',
  'form.section.basics': '计划基本信息',
  'form.section.pricing': '{type}定价',
  'form.pricingFallback': '保护',
  'form.section.appearance': '外观',
  'form.section.fulfillment': '履约',

  'form.type.shipping_protection': '运费保护',
  'form.type.shipping_protection.help': '保障顾客订单在运输途中不丢失、不受损、不被盗。',
  'form.type.warranty': '延长保修',
  'form.type.warranty.help': '对制造缺陷和正常磨损提供固定期限的保障。',
  'form.type.return_insurance': '退货保障',
  'form.type.return_insurance.help': '顾客可在规定期限内退货并获得全额退款。',
  'form.type.custom': '自定义保障',
  'form.type.custom.help': '您自定义的保障文案。',

  'form.defaults.untitledPlan': '未命名计划',
  'form.defaults.viewTerms': '查看条款',
  'form.defaults.shipping_protection.displayName': '运费保护',
  'form.defaults.shipping_protection.description': '保障您的订单不丢失、不受损、不被盗。',
  'form.defaults.warranty.displayName': '延长保修',
  'form.defaults.warranty.description': '承保制造缺陷与正常磨损,保修 2 年。',
  'form.defaults.return_insurance.displayName': '退货保障',
  'form.defaults.return_insurance.description': '14 天内退回任意商品,全额退款,无需理由。',
  'form.defaults.custom.displayName': '保护计划',
  'form.defaults.custom.description': '为您的订单添加保障。',

  'form.lang.select': '选择语言',
  'form.lang.default': '{name}(默认)',
  'form.translated': '(已翻译)',

  'form.field.planName.label': '计划名称(内部)',
  'form.field.planName.help': '仅供您参考 —— 顾客永远不会看到',
  'form.field.nameRequired': '请输入内部名称',
  'form.field.displayName.label': '显示名称',
  'form.field.displayNameRequired': '请输入显示名称',
  'form.field.displayName.placeholder': '显示名称',
  'form.field.displayName.help': '显示在购物车和结账页,面向顾客',
  'form.field.displayName.helpPreset': '显示给使用{lang}浏览的顾客',
  'form.field.displayName.helpPresetFallback': '显示给使用{lang}浏览的顾客 —— 留空时回退到{primary}',
  'form.field.description.label': '描述',
  'form.field.description.placeholder': '描述',
  'form.field.description.help': '显示在计划名称下方的简短顾客文案',
  'form.field.disabledDescription.label': '未勾选时的描述',
  'form.field.disabledDescription.placeholder': '可选 —— 计划未勾选时显示',
  'form.field.disabledDescription.help': '计划复选框未勾选时显示(留空时回退到上方描述)',
  'form.field.footer.label': '页脚',
  'form.field.footerText.label': '页脚文字',
  'form.field.footerLink.label': '页脚链接',
  'form.field.footerLink.help': '页脚文字的链接地址',

  'form.price.type.label': '价格类型',
  'form.price.fixed': '金额($)',
  'form.price.percentage': '百分比(%)',
  'form.price.advanced': '高级设置',
  'form.price.pctSummary': '订单金额的 {pct}%,从 ${min} 起、按 ${inc} 递增,最高至 ${max} —— 计划商品共 {count} 个变体',
  'form.price.tiersSummary_other': '计划商品将生成 1 个 {base} 变体,另加 {count} 个购物车金额区间变体',

  'form.validation.priceRequired': '请输入大于 0 的数值',
  'form.validation.priceMax100': '百分比不能超过 100',
  'form.validation.warrantyYears': '请输入 1 到 5 年之间的期限',
  'form.validation.returnDays': '请输入 7 到 365 天之间的期限',
  'form.validation.maxGreaterThanMin': '最大值必须大于最小值',
  'form.validation.variantIdNumeric': '变体 ID 必须为数字(隐藏计划变体的 ID)',

  'form.icon.label': '图标',
  'form.icon.useEmoji': '使用 {emoji} 作为计划图标',
  'form.icon.removeCustom': '移除自定义图标,恢复使用盾牌图标',
  'form.icon.upload': '上传自定义图标图片',
  'form.icon.uploadButton': '上传',
  'form.icon.uploading': '图标上传中',
  'form.icon.uploadHelp': '上传您自己的图标 —— 支持 PNG、JPEG、GIF 或 WebP,最大 5 MB。',
  'form.icon.error.notImage': '请选择图片文件(PNG、JPEG、GIF 或 WebP)。',
  'form.icon.error.tooLarge': '图片必须小于或等于 5 MB。',

  'form.fulfillment.intro': '选择保护商品何时被标记为已履约。',
  'form.fulfillment.manually': '手动履约',
  'form.fulfillment.first_item': '订单中首个商品履约时标记为已履约',
  'form.fulfillment.all_items': '订单中所有其他商品履约时标记为已履约',
  'form.fulfillment.immediately': '订单创建后立即标记为已履约',

  'form.adv.title': '高级设置',
  'form.adv.minPrice': '最低价格',
  'form.adv.minPriceHelp': '第一个变体的价格 —— 计划收取的最低费用',
  'form.adv.increment': '递增金额',
  'form.adv.incrementHelp': '生成的变体之间的价格步长',
  'form.adv.maxPriceLabel': '最高价格:',
  'form.adv.explanation': '计划商品将生成 {buckets} 个变体:{min} 占一个变体,其余 {rest} 个变体按 {inc} 递增,最高价格为 {max}。结账时顾客支付首个不低于购物车小计 {pct}% 的变体 —— 例如 $100 的购物车按 2% 计算目标为 $2.00,因此适用 $3.01 档位的变体。 ',
  'form.learnMore': '了解更多',

  'form.tiers.title': '按购物车金额定价',
  'form.tiers.minCol': '购物车最小金额',
  'form.tiers.maxCol': '购物车最大金额',
  'form.tiers.priceCol': '保护价格',
  'form.tiers.addTier': '添加新规则',
  'form.tiers.deleteTier': '删除规则 {index}',
  'form.tiers.explanation': '每条规则都需要最小值、最大值和价格(规则可以重叠 —— 按第一条匹配的规则生效)。每条规则会在计划商品上生成独立变体。若购物车总额不匹配任何规则,则适用主设置中的固定价格。 ',
  'form.tiers.error.minRequired': '请输入购物车最小金额',
  'form.tiers.error.maxRequired': '请输入购物车最大金额',
  'form.tiers.error.priceRequired': '请输入保护价格',
  'form.tiers.error.pricePositive': '价格必须大于 0',
  'form.tiers.error.minMax': '最小值必须小于或等于最大值',

  // ===== Save bar =====
  'savebar.unsavedChanges': '有未保存的更改',
  'savebar.discard': '放弃',
  'savebar.saving': '保存中',

  // ===== Preview panel =====
  'preview.title': '预览',
  'preview.simulatedSubtotal': '模拟购物车小计',
  'preview.cart': '购物车',
  'preview.product': '商品',
  'preview.total': '总计',
  'preview.subtotal': '小计',
  'preview.checkout': '结账',
  'preview.noPlans': '暂无启用的计划 —— 顾客不会看到此小组件。',
  'preview.autoAdded': '自动添加',
  'preview.unsaved': '未保存',

  // ===== Settings page =====
  'settings.title': '设置',
  'settings.language.title': '语言偏好',
  'settings.language.help': '当您访问 FlexCover 时,这是为您显示的语言。您商店的语言不会受到影响。',
  'settings.language.label': '语言',
  'settings.language.updated': '语言已更新',
  'settings.language.saveFailed': '保存语言偏好失败:{message}'
};

export default zhCN;
